import { isLocaleCA } from '@libs/core';
import type { ProductHit } from '@libs/algolia';
import type { GetRecommendationsParams } from '@libs/common-types';
import { client } from '../../client';
import { CWEA_ENDPOINTS } from '../../constants';

export async function getProductRecommendations(
    params: GetRecommendationsParams
): Promise<ProductHit[]> {
    const url = CWEA_ENDPOINTS.recommendations.getProductRecommendations({
        locale: isLocaleCA() ? 'CA' : 'USA',
        ...params,
    });
    return (
        (await client.cwea<ProductHit[]>(url, {
            cache: 'no-store',
        })) ?? []
    );
}
